<div class="container mt-5">
  <div style="text-align:center">
    <img src="https://isp.bg/wp-content/uploads/2018/09/logo-ePay.png" style="width:100px;margin-bottom:30px;" />
  </div>
  <div class="alert alert-primary" role="alert">
    Моля имайте в предвид,  е реално потвърждаване на плащането, ще се случи до няколко часа,
    след реалното плащане в ЕПей или на съответната им каса
  </div> 
  <form (ngSubmit)="submitPayment(paymentForm)" #paymentForm="ngForm" class="mt-4">
    <div class="form-group" style="text-align:center;">
      <label>Метод на плащане</label><br>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="paylogin" name="paymentMethod" checked="checked" ngModel value="paylogin" required>
        <label class="form-check-label" for="paylogin">Чрез Профил в Изи Пей</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="credit_paydirect" name="paymentMethod" ngModel value="credit_paydirect" required>
        <label class="form-check-label" for="credit_paydirect">чрез кредитна/дебитна карта</label>
      </div>
    </div>
    <div class="form-group">
      <label for="amount">Сума</label>
      <input type="number" class="form-control" id="amount" name="amount" value="amount" ngModel disabled>
    </div>
    <div style="text-align:right;">
      <button type="submit" class="btn btn-primary mt-3">Плати</button>
    </div>
 
  </form>
</div>
